import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
export default new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  }, {
    path: '/',
    component: function component() {
      return import( /* webpackChunkName: "home" */"../components/common/Home.vue");
    },
    meta: {
      title: '管理系统'
    },
    children: [{
      path: '/404',
      component: function component() {
        return import( /* webpackChunkName: "404" */"../components/page/404.vue");
      },
      meta: {
        title: '404'
      }
    }, {
      path: '/403',
      component: function component() {
        return import( /* webpackChunkName: "403" */"../components/page/403.vue");
      },
      meta: {
        title: '403'
      }
    }, {
      path: '/message',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/page/Tabs.vue");
      },
      meta: {
        title: '消息通知'
      }
    }, {
      path: '/company',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/orchard/company/company.vue");
      },
      meta: {
        title: '公司管理'
      }
    }, {
      path: '/userManage',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/orchard/user/userManage.vue");
      },
      meta: {
        title: '用户管理'
      }
    }, {
      path: '/companyTool',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/orchard/permission/companyTool.vue");
      },
      meta: {
        title: '公司功能集'
      }
    }, {
      path: '/menu',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/orchard/menu/index.vue");
      },
      meta: {
        title: '菜单管理'
      }
    }, {
      path: '/problemFeedback',
      component: function component() {
        return import( /* webpackChunkName: "donate" */"../components/orchard/problem/index.vue");
      },
      meta: {
        title: '问题反馈'
      }
    }]
  }, {
    path: '/login',
    component: function component() {
      return import( /* webpackChunkName: "login" */"../components/page/Login.vue");
    },
    meta: {
      title: '登录'
    }
  }, {
    path: '*',
    redirect: '/404'
  }]
});